import { AccordionDisclosure } from 'theme';

const SelectableAccordion = class extends AccordionDisclosure {
    accordionItems = this.querySelectorAll('.accordion__option');

    connectedCallback() {
        this.accordionItems.forEach(accordionItem => {
            accordionItem.addEventListener('click', (e) => {
                this.setSelectedOption(e, accordionItem)
            });
        })
    }

    setSelectedOption(e, item) {
         const selEl = this.querySelector('div[data-field="selected-value"]');
            if (selEl) {
                selEl.innerHTML = item.outerHTML;
            }
    }
};

if (!customElements.get('selectable-accordion')) {
    window.customElements.define('selectable-accordion', SelectableAccordion);
}
